import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { GET_DOCUMENT_LIST_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class DocumentList extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = [];

  url = GET_DOCUMENT_LIST_URL;

  constructor(applicationId) {
    super();
    const paramList = [applicationId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
